import React from 'react';
import axios from 'axios';
import { instanceOf } from 'prop-types';
import { useState } from 'react';
import * as urls from '../../actions/urlTypes';
import * as types from '../../actions/actionTypes';
import CALocationMemriPopup from './CALocationMemriPopup';
import { withStyles } from '@material-ui/core/styles';
import MuiTooltip from '@material-ui/core/Tooltip';
import {
  useDispatch,
  useSelector,
} from '../../components/common/react-redux-hooks';
import { getDetailByContractId } from '../../actions/contractAdminActions';

const CAContractsList = props => {
  const [locationValue, setLocationValue] = useState('');
  const [memriPopup, setMemriPopup] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  const { selectedContractId } = useSelector(state => ({
    selectedContractId: state.contractAdmin.selectedContractId,
  }));

  const emptyMemriObject = [
    {
      memriUser: '',
      locationId: '',
      seats: '',
      index: '0',
      createdTs: '',
      updatedTs: '',
      status: '',
    },
  ];

  const [userAddArray, setUserAddArray] = useState(emptyMemriObject);
  const [userTempArray, setUserTempArray] = useState([]);

  const editlocation = (item, index, section) => {
    props.setEditData(item, index, section);
    dispatch({
      type: types.SET_SELECTED_LOCATION_ID,
      payload: item.locationId,
    });
  };

  const deleteLocation = (item, index, section) => {
    props.deleteLocation(item, index, section);
  };

  const memriLocation = item => {
    let tempResult = [];
    const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/getExistingMemriUsers/${item.locationId}`;

    axios({
      url,
      method: 'get',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
    })
      .then(response => {
        setUserAddArray(response.data.data);
        setUserTempArray(response.data.data);
        tempResult = response.data.data;
        setMemriPopup(true);
        setIsModalOpen(true);
      })
      .catch(response => {});

    if (tempResult.length < 1) {
      const newState = userAddArray.map(obj => {
        setLocationValue(item.locationId);
        return { ...obj, locationId: item.locationId, status: 'newUser' };
      });
      setUserAddArray(newState);
      setUserTempArray(newState);
      setMemriPopup(true);
      setIsModalOpen(true);
    }
  };

  const closePopup = () => {
    setUserAddArray(emptyMemriObject);
    setShowError(false);
    setMemriPopup(false);
    setIsModalOpen(false);
    setShowErrorMessage('');
    setShowError(false);
  };

  const onChange = (e, fieldValue, indexNumber) => {
    e.preventDefault();
    const sourceVal = e.target !== undefined ? e.target.value : e;

    let target = '';
    if (fieldValue === 'userId') {
      if (sourceVal.length > 0) {
        target = sourceVal.replace(/[^a-z0-9_.-]/gi, '');
      }
    } else if (fieldValue === 'seats') {
      if (sourceVal.length > 0) {
        target = sourceVal;
      }
    }
    setShowErrorMessage('');
    setShowError(false);
    if (fieldValue === 'userId' && target.length > 30) {
      setShowErrorMessage('Login ID cannot be greater than 30.');
      setShowError(true);
      return;
    }

    let checkFlag = false;
    let newTempArray = userTempArray.map((item, index) => {
      if (
        index === indexNumber &&
        fieldValue === 'userId' &&
        item.memriUser === target
      ) {
        checkFlag = true;
      }

      if (
        index === indexNumber &&
        fieldValue === 'seats' &&
        item.seats === target
      ) {
        checkFlag = true;
      }
      return checkFlag;
    });

    if (!checkFlag) {
      let newState = [];
      if (userAddArray.length > 0) {
        newState = userAddArray.map((item, index) => {
          if (index === indexNumber && fieldValue === 'userId') {
            const statusVal =
              item.status === 'newUser'
                ? 'newUser'
                : target.length > 0
                ? 'updatedUser'
                : 'deletedUser';
            return { ...item, memriUser: target, status: statusVal };
          }
          if (index === indexNumber && fieldValue === 'seats') {
            const statusVal =
              item.status === 'newUser'
                ? 'newUser'
                : target.length > 0
                ? 'updatedUser'
                : 'deletedUser';
            return { ...item, seats: target, status: statusVal };
          }

          return {
            ...item,
            status: item.status || 'existingUser',
          };
        });
      } else {
        newState = sourceVal;
      }
      setUserAddArray(newState);
    } else {
      const elseState = userAddArray.map((item, index) => {
        if (index === indexNumber && fieldValue === 'userId') {
          return {
            ...item,
            memriUser: target,
            status: item.status === 'newUser' ? 'newUser' : 'existingUser',
          };
        }

        if (index === indexNumber && fieldValue === 'seats') {
          return {
            ...item,
            seats: target,
            status: item.status === 'newUser' ? 'newUser' : 'existingUser',
          };
        }

        return item;
      });

      setUserAddArray(elseState);
    }
  };
  const addNewRow = () => {
    const tempArray = userAddArray;
    const tempObj = {
      memriUser: '',
      locationId: locationValue,
      seats: '',
      status: 'newUser',
      createdTs: null,
      updatedTs: null,
    };
    tempArray.push(tempObj);
    setMemriPopup(false);
    setIsModalOpen(false);
    setUserAddArray(tempArray);
    setTimeout(() => {
      setMemriPopup(true);
      setIsModalOpen(true);
    }, 10);
  };

  const savePopUpData = () => {
    const deleteState = userAddArray.map(obj1 => {
      if (obj1.index !== '') {
        delete obj1.index;
        return obj1;
      }
    });

    setUserAddArray(deleteState);

    const newState = userAddArray.map(obj => {
      if (obj.memriUser !== '' && obj.seats === '') {
        return { ...obj, seats: parseInt('0', 10) };
      }
      return { ...obj, seats: parseInt(obj.seats, 10) };
    });

    setTimeout(() => {
      const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/saveMemriUsers`;

      axios({
        url,
        method: 'post',
        headers: {
          accept: 'application/json;charset=UTF-8',
        },
        data: newState,
        withCredentials: true,
        responseType: 'json',
      })
        .then(response => {
          dispatch(getDetailByContractId(selectedContractId));
          setMemriPopup(false);
          setIsModalOpen(false);
          setUserAddArray(emptyMemriObject);
          setShowErrorMessage('');
          setShowError(false);
        })
        .catch(response => {
          setShowErrorMessage(response.response.data.message);
          setShowError(true);
        });
    }, 200);
  };
  const Tooltip = withStyles(() => ({
    tooltip: {
      fontSize: 12,
      color: '#000',
      background: '#fff',
      border: '1px solid #90a3b7',
      fontWeight: 400,
      fontFamily: '"Open Sans", sans-serif',
      width: 'auto',
      position: 'relative',
      bottom: '70px',
    },
  }))(MuiTooltip);

  function Tooltips({ title }) {
    return (
      <Tooltip title={title}>
        <span className="content-list">{title}</span>
      </Tooltip>
    );
  }

  return (
    <div>
      <div className="ca-add-contract-List-heading">
        Location List (within Account)
      </div>
      <div className="contractList-header">
        <div className="container-header">
          <span className="content-list">Location Name &nbsp;</span>
          <span className="content-list">Company Name &nbsp;</span>
        </div>

        <div>
          <span>Actions</span>
        </div>
      </div>
      <div>&nbsp;</div>
      {props.data.length > 0 &&
        props.data.map((item, index) => {
          return (
            <div disabled={props.selectedIndex === index}>
              {item.locationName && (
                <div className="contractList">
                  <div className="container-header">
                    <Tooltips title={item.locationName} />
                    <span className="content-list">
                      {item.companyName} &nbsp;
                    </span>
                  </div>
                  <div>
                    <button
                      type="button"
                      onClick={() => memriLocation(item)}
                      className={
                        item.memriUsers &&
                        !(
                          item.memriUsers === null ||
                          item.memriUsers.length === 0
                        ) &&
                        'active-chart-type'
                      }
                    >
                      MEMRI
                    </button>
                    <button
                      type="button"
                      disabled={props.selectedIndex === index}
                      onClick={() => editlocation(item, index, 'location')}
                      className={
                        props.selectedIndex === index
                          ? 'disableLocRow'
                          : 'normalLowRow'
                      }
                    >
                      | Edit
                    </button>
                    <button
                      type="button"
                      disabled={
                        (props.selectedIndex == '' && index === 0) ||
                        props.selectedIndex === index ||
                        item.isAffiliated ||
                        props.data.length === 1
                      }
                      onClick={() => deleteLocation(item, index, 'location')}
                      title={
                        item.isAffiliated
                          ? 'Location cannot be deleted because Entitlement is associated to it'
                          : ''
                      }
                      className={
                        (props.selectedIndex == '' && index === 0) ||
                        props.selectedIndex === index ||
                        item.isAffiliated ||
                        props.data.length === 1
                          ? 'disableLocRow'
                          : 'normalLowRow'
                      }
                    >
                      {' '}
                      | Delete
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      {memriPopup && (
        <CALocationMemriPopup
          close={closePopup}
          addNewRow={addNewRow}
          fieldChange={onChange}
          save={savePopUpData}
          isModalOpen={isModalOpen}
          showErrorMessage={showErrorMessage}
          showError={showError}
          userArray={userAddArray}
        />
      )}
    </div>
  );
};

CAContractsList.propTypes = {
  data: instanceOf(Object).isRequired,
};

CAContractsList.defaultProps = {
  data: null,
};

export default CAContractsList;
